import { spawn } from "redux-saga/effects"

import { saga as user } from "./user"

export default function* rootSaga() {
  yield spawn(user)
}
